// extracted by mini-css-extract-plugin
export default {"container":"AdminPoolUser_container__ECk4e","staked_asset":"AdminPoolUser_staked_asset__6YSTE","prop":"AdminPoolUser_prop__933mw"};